// Blog posts SEO – serrurerie urgence
// Each post has: slug, title, excerpt, cover, date, readMin, category, content (array of blocks)

export const BLOG_POSTS = [
  {
    slug: "porte-claquee-que-faire",
    title: "Porte claquée : que faire en urgence sans paniquer ?",
    excerpt:
      "Vous venez de claquer la porte avec les clés à l'intérieur. Voici les 5 bons réflexes avant d'appeler un serrurier d'urgence.",
    cover:
      "https://images.unsplash.com/photo-1582139329536-e7284fece509?auto=format&fit=crop&w=1600&q=80",
    date: "2026-02-04",
    readMin: 4,
    category: "Urgence",
    keywords: [
      "porte claquée",
      "serrurier urgence",
      "ouverture de porte",
      "clé à l'intérieur",
    ],
    content: [
      {
        type: "p",
        text: "Une porte claquée fait partie des urgences les plus fréquentes, et la panique est mauvaise conseillère. Avant de tenter quoi que ce soit, prenez 30 secondes pour respirer et appliquez ces 5 réflexes simples.",
      },
      { type: "h2", text: "1. Vérifiez si une autre entrée est accessible" },
      {
        type: "p",
        text: "Une fenêtre laissée entrouverte, une porte de service, un voisin ayant un double… Avant l'intervention payante, faites un tour rapide. Si c'est une porte simplement claquée (et non fermée à clé), un serrurier qualifié peut l'ouvrir en moins de 5 minutes sans dégât dans 95% des cas.",
      },
      { type: "h2", text: "2. Ne forcez jamais la serrure vous-même" },
      {
        type: "p",
        text: "Les vidéos YouTube montrant des techniques au pied-de-biche ou à la radio sont une fausse bonne idée : vous risquez de bloquer définitivement le mécanisme et de transformer une intervention à 89€ en remplacement complet à 350€+. Patientez.",
      },
      { type: "h2", text: "3. Appelez un serrurier certifié, pas la première annonce trouvée" },
      {
        type: "p",
        text: "Méfiez-vous des annonces \"15€\" sur Google : ce sont des prix d'appel illégaux. Un serrurier sérieux annonce un tarif clair par téléphone avant déplacement et fournit un devis écrit avant intervention. Demandez systématiquement le numéro SIRET et la mention A2P.",
      },
      { type: "h2", text: "4. Préparez vos justificatifs d'identité" },
      {
        type: "p",
        text: "Un serrurier honnête vous demandera une pièce d'identité ou un justificatif de domicile avant d'ouvrir la porte. C'est une garantie pour vous et pour lui. Ayez votre carte d'identité ou votre permis prêt.",
      },
      { type: "h2", text: "5. Conservez la facture pour votre assurance" },
      {
        type: "p",
        text: "La majorité des contrats d'assurance habitation incluent une garantie \"perte de clés\" ou \"serrurerie d'urgence\". Une facture détaillée, avec mention du matériel et du temps d'intervention, est nécessaire pour le remboursement.",
      },
      { type: "cta" },
    ],
  },
  {
    slug: "prix-ouverture-porte-serrurier",
    title: "Combien coûte une ouverture de porte par un serrurier en 2026 ?",
    excerpt:
      "Tarifs réels, fourchettes de prix par situation, majorations nuit/week-end : transparence complète sur le coût d'une intervention de dépannage.",
    cover:
      "https://images.unsplash.com/photo-1607863680198-23d4b2565df0?auto=format&fit=crop&w=1600&q=80",
    date: "2026-02-02",
    readMin: 5,
    category: "Tarifs",
    keywords: [
      "prix serrurier",
      "tarif ouverture de porte",
      "coût dépannage serrurier",
      "tarif urgence nuit",
    ],
    content: [
      {
        type: "p",
        text: "Le prix d'une ouverture de porte par un serrurier varie de 89€ à plus de 400€ selon le type de fermeture, l'horaire et la complexité. Voici une grille tarifaire honnête, basée sur les pratiques du marché en France en 2026.",
      },
      { type: "h2", text: "Tarif d'une porte simplement claquée (en journée)" },
      {
        type: "p",
        text: "C'est le cas le plus simple : la porte n'est pas fermée à clé, juste claquée. En journée (8h-19h), comptez entre 89€ et 150€ tout compris, déplacement inclus. L'intervention dure rarement plus de 15 minutes.",
      },
      { type: "h2", text: "Porte fermée à double tour ou avec une serrure 3 points" },
      {
        type: "p",
        text: "Plus complexe, l'ouverture nécessite un crochetage long ou parfois le perçage de la serrure. Tarif : 180€ à 280€ en journée. Si la serrure est endommagée ou doit être remplacée, ajoutez le prix du cylindre (à partir de 60€).",
      },
      { type: "h2", text: "Majoration nuit, dimanche et jours fériés" },
      {
        type: "p",
        text: "La nuit (19h-8h), le dimanche et les jours fériés, une majoration légale de 25 à 50% s'applique. Une porte claquée à 2h du matin coûtera donc entre 120€ et 220€. C'est encadré par le décret du 11 mars 2014 : tout dépassement doit être justifié.",
      },
      { type: "h2", text: "Frais cachés à éviter à tout prix" },
      {
        type: "p",
        text: "Méfiez-vous des \"frais de déplacement\" annoncés à 15€ qui se transforment en facture à 800€ après l'intervention. Un serrurier honnête vous donne le tarif TOTAL au téléphone, signe un devis avant de commencer, et vous remet une facture détaillée.",
      },
      { type: "h2", text: "Notre engagement tarifaire" },
      {
        type: "p",
        text: "Chez SOS Serrurier Express, nous annonçons systématiquement le prix exact au téléphone avant déplacement. Si une fois sur place le tarif change, nous quittons les lieux sans rien vous facturer. Devis écrit obligatoire avant toute intervention.",
      },
      { type: "cta" },
    ],
  },
  {
    slug: "eviter-arnaques-serrurier",
    title: "10 signes d'un serrurier honnête (et 5 arnaques classiques à fuir)",
    excerpt:
      "Comment reconnaître un vrai serrurier d'urgence ? Les bonnes pratiques, les pièges du référencement Google, et la check-list à dégainer avant de signer.",
    cover:
      "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&w=1600&q=80",
    date: "2026-01-28",
    readMin: 6,
    category: "Conseils",
    keywords: [
      "arnaque serrurier",
      "serrurier honnête",
      "éviter arnaque dépannage",
      "fausse facture serrurier",
    ],
    content: [
      {
        type: "p",
        text: "Le secteur du dépannage serrurerie compte malheureusement de nombreux acteurs peu scrupuleux qui profitent de l'urgence pour gonfler les factures. Voici une check-list pratique pour démasquer un serrurier sérieux.",
      },
      { type: "h2", text: "Les 10 signes d'un serrurier honnête" },
      {
        type: "p",
        text: "1. Il annonce un tarif clair au téléphone — pas de \"on verra sur place\".\n2. Il fournit un numéro SIRET vérifiable.\n3. Il mentionne la certification A2P pour le matériel posé.\n4. Il signe un devis détaillé AVANT de commencer.\n5. Il vous demande une pièce d'identité.\n6. Il accepte plusieurs moyens de paiement (CB, virement).\n7. Il a une vraie adresse et un numéro fixe.\n8. Il propose une garantie sur la pose.\n9. Il intervient en moins d'une heure dans son périmètre annoncé.\n10. Il parle clairement, sans pression psychologique.",
      },
      { type: "h2", text: "Les 5 arnaques classiques à fuir absolument" },
      {
        type: "p",
        text: "Arnaque 1 : Le \"15€ tout compris\" sur Google. Prix d'appel illégal qui se termine à 800€.\nArnaque 2 : Le perçage systématique. Si on vous dit \"obligatoire de percer\" sans avoir tenté le crochetage 5 minutes, fuyez.\nArnaque 3 : Le remplacement de serrure imposé. Une serrure en bon état n'a pas besoin d'être changée après une simple ouverture.\nArnaque 4 : Le cylindre \"haut de gamme\" facturé 400€. Les vrais cylindres A2P★★★ coûtent 90 à 180€ TTC matériel.\nArnaque 5 : Pas de devis, pas de facture. C'est illégal et vous n'aurez aucun recours.",
      },
      { type: "h2", text: "Que faire si vous avez été arnaqué ?" },
      {
        type: "p",
        text: "Conservez tous les documents (facture, devis, photos). Saisissez la DGCCRF (signal.conso.gouv.fr) et déposez plainte au commissariat. Pour les paiements en CB, contactez votre banque pour un éventuel charge-back dans les 8 semaines.",
      },
      { type: "cta" },
    ],
  },
  {
    slug: "blindage-porte-prix-normes-a2p",
    title: "Blindage de porte : prix, normes A2P et vrais avantages en 2026",
    excerpt:
      "Tout savoir sur le blindage de porte : différence entre porte blindée et bloc-porte, normes A2P BP1/BP2/BP3, et combien ça coûte vraiment.",
    cover:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1600&q=80",
    date: "2026-01-20",
    readMin: 7,
    category: "Sécurité",
    keywords: [
      "blindage porte",
      "porte blindée prix",
      "norme A2P BP",
      "sécurité appartement",
    ],
    content: [
      {
        type: "p",
        text: "Le blindage de porte est l'investissement sécurité numéro 1 pour un appartement. Mais entre le simple blindage feuillure et le bloc-porte certifié BP3, les écarts de prix et de protection sont énormes. Décryptage.",
      },
      { type: "h2", text: "Blindage simple ou bloc-porte ? La différence" },
      {
        type: "p",
        text: "Un blindage classique est une plaque d'acier (1,5 à 2,5 mm) fixée sur votre porte existante, avec renforts de gâche et serrure 3 ou 5 points. Tarif : 1 200€ à 2 500€ posé.\n\nUn bloc-porte blindé remplace l'ensemble porte + cadre par un système monobloc en acier conçu d'usine. Tarif : 2 800€ à 5 500€ posé selon la certification A2P.",
      },
      { type: "h2", text: "Comprendre les normes A2P BP1, BP2 et BP3" },
      {
        type: "p",
        text: "La certification A2P (Assurance Prévention Protection), délivrée par le CNPP, mesure la résistance aux outils d'effraction.\n\n• BP1 : résiste 5 minutes minimum (cambriolage opportuniste)\n• BP2 : résiste 10 minutes (cambriolage planifié)\n• BP3 : résiste 15 minutes (effraction lourde, outils thermiques)\n\nPour un appartement classique, le BP1 est suffisant. Pour un rez-de-chaussée ou un logement isolé, optez pour BP2 minimum.",
      },
      { type: "h2", text: "Économies sur l'assurance habitation" },
      {
        type: "p",
        text: "La majorité des assureurs accordent 5 à 15% de réduction sur la prime habitation après l'installation d'un bloc-porte A2P. Sur 10 ans, l'économie peut couvrir une partie significative du coût de pose. Demandez systématiquement une attestation à votre serrurier.",
      },
      { type: "h2", text: "Combien de temps pour la pose ?" },
      {
        type: "p",
        text: "Comptez une demi-journée pour un blindage simple, une journée pour un bloc-porte. L'intervention nécessite de vider le seuil de la porte mais ne salit quasiment pas le logement (chantier propre).",
      },
      { type: "cta" },
    ],
  },
  {
    slug: "serrures-connectees-meilleures-marques-2026",
    title: "Serrures connectées : les 5 meilleures marques en 2026",
    excerpt:
      "Nuki, Yale, Igloohome, SwitchBot, Welock : comparatif des serrures connectées les plus fiables, leurs prix et leurs limites.",
    cover:
      "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1600&q=80",
    date: "2026-01-12",
    readMin: 6,
    category: "Domotique",
    keywords: [
      "serrure connectée",
      "Nuki",
      "Yale connectée",
      "serrure smart",
      "serrure bluetooth",
    ],
    content: [
      {
        type: "p",
        text: "La serrure connectée n'est plus un gadget : avec la généralisation d'Airbnb, du télétravail et des locations courte durée, elle devient un standard. Voici notre comparatif 2026 des modèles que nous installons quotidiennement.",
      },
      { type: "h2", text: "1. Nuki Smart Lock 4 Pro — Le couteau suisse (199€-329€)" },
      {
        type: "p",
        text: "Le leader européen. S'installe sur la serrure existante sans changer le cylindre, compatible Apple HomeKit, Google Home et Alexa. Wi-Fi intégré, batterie 6 mois. Idéal pour les locations Airbnb. Inconvénient : visible côté intérieur.",
      },
      { type: "h2", text: "2. Yale Linus L2 — La discrétion premium (249€-399€)" },
      {
        type: "p",
        text: "Plus discret que Nuki, design soigné, intégration native Apple Home. Très fiable mais batteries (4xAA) à changer tous les 4-6 mois. Compatible avec la majorité des cylindres européens.",
      },
      { type: "h2", text: "3. Igloohome Deadbolt 2S — La référence sans Wi-Fi (199€-279€)" },
      {
        type: "p",
        text: "Fonctionne sans Wi-Fi grâce à un système de PIN à durée limitée généré à distance. Idéal pour les locations courtes. Plus encombrant mais autonomie de 10 mois.",
      },
      { type: "h2", text: "4. SwitchBot Lock Pro — Le rapport qualité/prix (139€-189€)" },
      {
        type: "p",
        text: "L'option économique sérieuse. Installation 100% réversible (vissage sur porte, pas de perçage). Application correcte, intégration Matter. Idéal pour un premier équipement.",
      },
      { type: "h2", text: "5. Welock Touch41 — Le cylindre connecté complet (299€-449€)" },
      {
        type: "p",
        text: "Remplace intégralement votre cylindre par un système connecté avec lecteur d'empreinte digitale. Plus invasif à installer mais aucun élément visible côté intérieur. Notre choix pour les résidences principales haut de gamme.",
      },
      { type: "h2", text: "Faut-il garder une serrure mécanique en backup ?" },
      {
        type: "p",
        text: "Oui, absolument. Tous les modèles cités conservent un cylindre mécanique de secours. En cas de panne batterie ou bug logiciel, votre clé classique fonctionne toujours. Ne tombez pas dans le piège des serrures 100% électroniques sans secours mécanique.",
      },
      { type: "cta" },
    ],
  },
  {
    slug: "cle-cassee-dans-serrure",
    title: "Clé cassée dans la serrure : comment l'extraire sans tout casser",
    excerpt:
      "Le bout de la clé est resté coincé dans le cylindre. Voici les techniques de pro pour l'extraire et les erreurs qui rendent la situation pire.",
    cover:
      "https://images.unsplash.com/photo-1606166325683-e6deb697d301?auto=format&fit=crop&w=1600&q=80",
    date: "2026-01-08",
    readMin: 5,
    category: "Urgence",
    keywords: [
      "clé cassée",
      "extraction clé",
      "clé bloquée",
      "cylindre bouché",
    ],
    content: [
      {
        type: "p",
        text: "Une clé qui se brise dans la serrure est une situation classique : usure du métal, force excessive, gel hivernal. Avant d'appeler un serrurier, voici ce qu'il faut absolument éviter, et les méthodes qui marchent vraiment.",
      },
      { type: "h2", text: "Les 3 erreurs qui empirent la situation" },
      {
        type: "p",
        text: "1. Pousser le morceau plus profond avec un autre objet : il devient impossible à attraper.\n2. Mettre du WD-40 ou de l'huile : les particules métalliques bouchent le mécanisme à long terme.\n3. Tourner la serrure dans tous les sens : vous risquez de casser une autre goupille.",
      },
      { type: "h2", text: "La méthode du brin de scie à métaux" },
      {
        type: "p",
        text: "Si le morceau dépasse légèrement, glissez la lame d'une scie à métaux (uniquement les dents tournées vers vous) le long du cylindre. Faites pivoter d'un quart de tour pour accrocher le métal puis tirez doucement. Réussite : 70% des cas.",
      },
      { type: "h2", text: "La pince fine ou la pince à épiler de précision" },
      {
        type: "p",
        text: "Si vous avez une vraie pince à serrurier (extracteur), insérez-la jusqu'au bout du fragment et tirez en ligne droite. À défaut, une pince à épiler médicale fait l'affaire pour les fragments dépassant de 2 mm.",
      },
      { type: "h2", text: "Quand renoncer et appeler un pro" },
      {
        type: "p",
        text: "Si après 10 minutes vous n'avez pas réussi, ou si la clé est cassée à l'intérieur du cylindre (rien ne dépasse), arrêtez. Un serrurier dispose d'un kit d'extraction à crochets fins (~50 outils) qui fait le travail en 5-15 minutes. Tarif moyen : 80 à 150€ en journée.",
      },
      { type: "cta" },
    ],
  },
  {
    slug: "serrure-tourne-dans-le-vide",
    title: "Serrure qui tourne dans le vide : 5 causes et leurs solutions",
    excerpt:
      "Votre clé tourne mais la porte ne s'ouvre plus. Voici les pannes mécaniques classiques, leur diagnostic et les bons gestes avant de tout démonter.",
    cover:
      "https://images.unsplash.com/photo-1508873535684-277a3cbcc4e8?auto=format&fit=crop&w=1600&q=80",
    date: "2026-01-04",
    readMin: 5,
    category: "Pannes",
    keywords: [
      "serrure tourne dans le vide",
      "panne serrure",
      "carré de poignée cassé",
      "réparation serrure",
    ],
    content: [
      {
        type: "p",
        text: "Quand une clé tourne sans actionner le pêne, la cause est mécanique. Voici les 5 diagnostics les plus fréquents que nous rencontrons sur le terrain.",
      },
      { type: "h2", text: "Cause 1 : le carré de la poignée est cassé" },
      {
        type: "p",
        text: "Le carré métallique qui transmet le mouvement de la poignée au pêne demi-tour s'est rompu. C'est typique sur les portes de plus de 15 ans. Solution : remplacement du carré + parfois de la garniture (45 à 90€ matériel).",
      },
      { type: "h2", text: "Cause 2 : le panneton du cylindre est désolidarisé" },
      {
        type: "p",
        text: "Le panneton (la pièce qui sort du cylindre quand vous tournez la clé) s'est détaché. Aucun outil maison ne le répare ; il faut sortir et remplacer le cylindre. Tarif cylindre A2P★ : 60 à 120€ + pose 80 à 130€.",
      },
      { type: "h2", text: "Cause 3 : un goujon de gâche s'est désaligné" },
      {
        type: "p",
        text: "Si la porte a légèrement bougé (porte gonflée par l'humidité, fondations qui ont travaillé), le pêne ne trouve plus la gâche. Test : déposez la gâche et tournez la clé dans le vide. Si tout fonctionne, il faut juste réajuster la gâche.",
      },
      { type: "h2", text: "Cause 4 : le mécanisme est encrassé ou rouillé" },
      {
        type: "p",
        text: "L'humidité, la poussière et le temps grippent le mécanisme. Surtout PAS d'huile : utilisez un lubrifiant graphite sec en aérosol (vendu en quincaillerie ~6€). Insérez la canule dans le cylindre, 2 secondes, puis tournez la clé 10 fois.",
      },
      { type: "h2", text: "Cause 5 : ressort de pêne dormant cassé" },
      {
        type: "p",
        text: "Sur les serrures à mortaiser, le ressort interne qui fait revenir le pêne dormant peut casser. Démontage de la serrure complet nécessaire. Si elle a plus de 10 ans, mieux vaut la remplacer (200 à 350€ pose comprise).",
      },
      { type: "cta" },
    ],
  },
  {
    slug: "changer-serrure-apres-cambriolage",
    title: "Faut-il changer toute la serrure après un cambriolage ?",
    excerpt:
      "Tentative d'effraction ou cambriolage : la porte tient mais la serrure est-elle encore fiable ? Voici la vraie réponse, point par point.",
    cover:
      "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&w=1600&q=80",
    date: "2025-12-28",
    readMin: 5,
    category: "Sécurité",
    keywords: [
      "cambriolage",
      "changer serrure après effraction",
      "tentative effraction",
      "remplacement cylindre",
    ],
    content: [
      {
        type: "p",
        text: "Après une tentative d'effraction, la première question est : faut-il tout changer, ou peut-on se contenter du cylindre ? Notre réponse, basée sur 12 000+ interventions.",
      },
      { type: "h2", text: "Cas 1 : tentative d'arrachement du cylindre" },
      {
        type: "p",
        text: "Si vous voyez des marques de pince autour du cylindre ou que celui-ci dépasse de 1mm de plus qu'avant, le métal a bougé en interne. Remplacement obligatoire du cylindre par un modèle A2P★★ ou A2P★★★ avec rosace anti-arrachement. Coût : 180 à 350€.",
      },
      { type: "h2", text: "Cas 2 : tentative de bumping ou crochetage" },
      {
        type: "p",
        text: "Aucune trace visible mais vous suspectez. Si vous aviez un cylindre standard (non A2P), il faut le changer pour un cylindre A2P★ minimum. Si c'était déjà un A2P★★ ou ★★★ : non, vos clés sont incopiables et le mécanisme intact.",
      },
      { type: "h2", text: "Cas 3 : pied-de-biche / défoncement" },
      {
        type: "p",
        text: "Si la porte a été forcée mécaniquement, même si elle tient, le coffre de serrure et la gâche ont subi un choc. Démontage et inspection obligatoires. Si l'âme acier de la serrure est tordue, remplacement complet (350 à 600€).",
      },
      { type: "h2", text: "Cas 4 : clés volées (sac à main, voiture)" },
      {
        type: "p",
        text: "Aucun débat : changement de cylindre dans la journée. Le voleur a souvent vos papiers et donc votre adresse. Coût : 120 à 250€ pour un cylindre A2P★. Votre assurance habitation rembourse souvent à 100% sur présentation du dépôt de plainte.",
      },
      { type: "h2", text: "Notre recommandation systématique" },
      {
        type: "p",
        text: "Après tout incident, profitez-en pour passer en cylindre A2P★★★ + rosace + serrure 3 points minimum. Le surcoût (~150€) est rentabilisé en 3 ans par la baisse de votre prime d'assurance habitation. Et vous dormez tranquille.",
      },
      { type: "cta" },
    ],
  },
  {
    slug: "prix-blindage-porte-appartement-2026",
    title: "Prix d'un blindage de porte d'appartement en 2026 : la vraie grille",
    excerpt:
      "Tarifs détaillés, options, normes A2P, aides financières : tout ce qu'il faut savoir avant de signer un devis blindage en 2026.",
    cover:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1600&q=80",
    date: "2025-12-20",
    readMin: 7,
    category: "Tarifs",
    keywords: [
      "prix blindage porte",
      "devis blindage appartement",
      "tarif porte blindée",
      "blindage A2P prix",
    ],
    content: [
      {
        type: "p",
        text: "Le marché du blindage de porte est opaque : les écarts vont de 800€ à 6 000€ pour des prestations qui semblent identiques. Voici la grille tarifaire 2026 pour vous aider à décrypter votre devis.",
      },
      { type: "h2", text: "Blindage simple (option économique) — 1 200 à 1 800€" },
      {
        type: "p",
        text: "Plaque acier 2 mm vissée sur votre porte existante + cornière pare-pince + serrure 3 points + cylindre A2P★. Adapté pour un appartement en étage, immeuble fermé. Pose en 4-6 heures.",
      },
      { type: "h2", text: "Blindage renforcé — 1 800 à 2 800€" },
      {
        type: "p",
        text: "Plaque acier 2,5-3 mm + renforts horizontaux + serrure 5 points + cylindre A2P★★ + judas optique. C'est notre recommandation pour la majorité des appartements parisiens. Pose en 6-8 heures.",
      },
      { type: "h2", text: "Bloc-porte blindé BP1 (porte + cadre neufs) — 2 800 à 3 800€" },
      {
        type: "p",
        text: "Remplace votre porte ET son cadre par un système monobloc certifié. Aspect personnalisable côté intérieur (chêne, blanc, etc.). Le BP1 résiste 5 minutes aux outils d'effraction. Pose en une journée.",
      },
      { type: "h2", text: "Bloc-porte blindé BP2 — 3 500 à 4 800€" },
      {
        type: "p",
        text: "Idem BP1 mais résistance 10 minutes. Recommandé pour les rez-de-chaussée et premiers étages. Souvent éligible à la \"prime sécurité\" de votre assureur (5-15% de réduction sur la prime habitation).",
      },
      { type: "h2", text: "Bloc-porte blindé BP3 — 4 800 à 6 500€" },
      {
        type: "p",
        text: "Le top : résistance 15 minutes, isolation phonique 42 dB. Réservé aux pavillons isolés, bijouteries domestiques ou clientèle exigeante. Garantie 10 ans.",
      },
      { type: "h2", text: "Aides et déductions disponibles" },
      {
        type: "p",
        text: "TVA réduite à 10% pour logement de plus de 2 ans (au lieu de 20%). Crédit d'impôt sécurité de 25% jusqu'à 8 000€ dans certaines communes (vérifiez votre mairie). Et surtout : -5 à 15% sur votre prime d'assurance habitation à vie.",
      },
      { type: "cta" },
    ],
  },
  {
    slug: "serrure-3-5-7-points-comparatif",
    title: "Serrure 3, 5 ou 7 points : laquelle choisir vraiment ?",
    excerpt:
      "Comparatif technique des serrures multipoints : nombre de points utiles, prix réel, certifications, et le piège marketing du \"plus c'est mieux\".",
    cover:
      "https://images.unsplash.com/photo-1606166325683-e6deb697d301?auto=format&fit=crop&w=1600&q=80",
    date: "2025-12-12",
    readMin: 6,
    category: "Sécurité",
    keywords: [
      "serrure 3 points",
      "serrure 5 points",
      "serrure 7 points",
      "comparatif serrure multipoints",
    ],
    content: [
      {
        type: "p",
        text: "Les fabricants poussent souvent vers le \"7 points\" pour gonfler la facture, alors que dans 80% des cas une serrure 3 ou 5 points est tout aussi efficace. Voici la vraie analyse.",
      },
      { type: "h2", text: "Serrure 3 points (haut, milieu, bas) — 180 à 320€" },
      {
        type: "p",
        text: "Le standard de la majorité des appartements parisiens. Trois pênes verticaux qui s'engagent dans la dormante. Suffisant pour 95% des situations résidentielles. Si certifié A2P★★, c'est largement assez face aux cambrioleurs opportunistes.",
      },
      { type: "h2", text: "Serrure 5 points (3 verticaux + 2 latéraux) — 280 à 480€" },
      {
        type: "p",
        text: "Ajoute deux pênes latéraux qui s'engagent dans le bâti côté gonds. Recommandé pour les portes anciennes (plus de 30 ans) où le bâti peut être attaqué. Bon rapport sécurité/prix pour les rez-de-chaussée.",
      },
      { type: "h2", text: "Serrure 7 points — 450 à 750€" },
      {
        type: "p",
        text: "Sept points d'ancrage. En pratique, peu d'apport sécuritaire supplémentaire face à un cambrioleur expérimenté (qui ciblera plutôt le cylindre ou les gonds). Réservez le 7 points aux portes très grandes (plus de 90 cm) ou aux locaux sensibles.",
      },
      { type: "h2", text: "Le facteur réellement décisif : le cylindre" },
      {
        type: "p",
        text: "Une serrure 7 points avec un cylindre standard se crochète en 90 secondes. Une serrure 3 points avec un cylindre A2P★★★ tient 15 minutes. Investissez prioritairement dans le cylindre (Picard Vigistar, Fichet F3D, Mul-T-Lock MT5+).",
      },
      { type: "h2", text: "Notre recommandation pour 90% des appartements" },
      {
        type: "p",
        text: "Serrure 3 points A2P★ (180€) + cylindre A2P★★★ (180€) + rosace anti-arrachement (40€) = 400€ matériel + 180-250€ pose. Soit ~600€ tout compris, et un niveau de protection supérieur à un 7 points avec cylindre standard.",
      },
      { type: "cta" },
    ],
  },
];

export const getPostBySlug = (slug) =>
  BLOG_POSTS.find((p) => p.slug === slug) || null;
